
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[creatorSlug]/cart",
      function () {
        return require("private-next-pages/[creatorSlug]/cart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[creatorSlug]/cart"])
      });
    }
  